<div *ngIf="notification" [ngClass]="{'notification-success': notification.type === 'success', 'notification-error': notification.type === 'error'}">
  {{ notification.message }}
</div>

<div class="flex flex-col mt-4">
    <div>
      <label for="stateSelect" class="ml-2">Select State:</label>
      <div class="flex flex-wrap mt-2">
        <div *ngFor="let state of states" 
             [class]="selectedState === state ? 'chip selected mr-2 mb-2' : 'chip mr-2 mb-2'" 
             (click)="selectState(state)">
          {{ getFullStateName(state) }}
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showTable && features.length > 0" class="table-container">
    <table class="package-table">
      <thead>
        <tr>
          <th>Feature</th>
          <th *ngFor="let pkg of packages">{{ pkg }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let feature of features">
          <td>{{ feature.featureName }}</td>
          <td *ngFor="let pkg of packages" class="checkbox-cell">
            <div class="checkbox-wrapper"
                 (mouseenter)="showPopup(feature, pkg)"
                 (mouseleave)="scheduleHidePopup()">
              <input type="checkbox"
                     [checked]="isFeatureInPackage(feature, pkg)"
                     (change)="toggleFeatureInPackage(feature, pkg)">
              <span class="pin-star" 
                    [class.pinned]="isPackagePinned(feature, pkg)"
                    [class.unpinned]="isFeatureInPackage(feature, pkg) && !isPackagePinned(feature, pkg)"
                    title=""
                    (click)="showPopup(feature, pkg); $event.stopPropagation()">★</span>
              
              <div *ngIf="activePopup.feature === feature.featureName && activePopup.package === pkg"
                   class="feature-popup"
                   title=""
                   (mouseenter)="cancelHidePopup()"
                   (mouseleave)="scheduleHidePopup()">
                <div *ngFor="let grpCode of featureGrpCodes" 
                     class="popup-option" 
                     (click)="toggleFeatureFlag(feature, pkg, grpCode); $event.stopPropagation()">
                  <span class="star-icon" [class.active]="getFeatureFlag(feature, pkg, grpCode)">★</span>
                  <span>{{ grpCode }}</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex justify-center mt-4" *ngIf="showTable && features.length > 0">
    <button (click)="onSave()" class="es-btn-primary" [disabled]="!isDirty">Save</button>
  </div>

  <div *ngIf="loading" class="loading">
    Loading package data...
  </div>

  <div *ngIf="showTable && features.length === 0" class="no-data">
    No features available for the selected state.
  </div>
